import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService, AlertService, GroupService, UserService} from "../services";
import {Subject} from 'rxjs';
import {User} from "../models";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {ServiceService} from "../services/service.service";
import {Service} from "../models/service";
import {ComponentTitleService} from "../services/componentTitle.service";

import {locale as polish} from './i18n/pl';
import {locale as english} from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {CardService} from "../services/card.service";
import {Card} from "../models/card";
import {CardLog} from "../models/cardLog";
import {CardLogService} from "../services/cardLog.service";

@Component({
    templateUrl: './cardHistory.component.html',
    styleUrls: ['./cardHistory.component.scss']
})
export class CardHistoryComponent implements OnDestroy, OnInit {
    id: string;
    user: User;
    card: Card;
    card9Expanded: boolean = false;
    view: string = 'preview';
    locale: string = 'pl';
    logs: CardLog[];
    visibleErrorHistory: boolean = false;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private serviceService: ServiceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private cardService: CardService,
        private cardLogService: CardLogService,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Customers');

        this.translationLoader.loadTranslations(polish, english);
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.user = this.route.snapshot.data.userData;
        this.card = this.route.snapshot.data.cardData;

        this.componentTitleService.addPart(this.user.firstName + ' ' + this.user.lastName);
        this.componentTitleService.addPart('Cards');
        this.componentTitleService.addPart(this.card.cardNumber.toString());
        this.componentTitleService.addPart('History');

        this.cardLogService.findCardLogs(this.card.uuid)
            .pipe(first())
            .subscribe((logs: CardLog[]) => {
                for (let i = 0; i < logs.length; i++) {
                    let date = new Date(logs[i].createdAt);
                    logs[i].timezoneOffset = date.getTimezoneOffset()/60;

                    if (logs[i].params['voucher'] === undefined) {
                        continue;
                    }

                    logs[i].params['voucher'] = JSON.parse(logs[i].params['voucher']);
                    for (let j=0; j<logs[i].params['voucher'].items.length; j++) {
                        logs[i].params['voucher'].items[j] = JSON.parse(logs[i].params['voucher'].items[j]);
                    }
                }
                this.logs = logs;
            });
    }

    ngOnDestroy(): void {

    }

    hideDataRow(key: string): boolean {
        const keys = [
            'cardUuid',
            'uuid',
            'serviceId',
            'isMainVoucher',
            'operator_id',
            'user_id',
            'resourceId',
            'orderId',
        ];

        return keys.includes(key);
    }

    changeHistoryVisibility(visible: boolean) {
        this.visibleErrorHistory = visible;
    }
}
